// extracted by mini-css-extract-plugin
module.exports = {"Button":"w_nT f_nT f_ny d_b8 d_cn d_cc d_d5","full":"w_sD d_5 d_bg","width100":"w_5 d_5","design3Pos":"w_sF d_bz"};